export const idX = argument => argument;

const compose2 = (f, g) => (...args) => f(g(...args));

export const compose = (...fns) => (fns.length > 0 ? fns.reduce(compose2) : idX);

const pipe2 = (f, g) => (...args) => g(f(...args));

export const pipe = (...fns) => (fns.length > 0 ? fns.reduce(pipe2) : idX);

export const mapValues = mapper => obj =>
	Object.assign(
		...Object.entries(obj).map(([key, value]) => ({
			[key]: mapper(value, key, obj),
		})),
	);

export const safeCall = (fn, args) => (typeof fn === "function" ? fn(...args) : undefined);

export const callIf = (predicate, thenFn, elseFn) => (...args) =>
	safeCall(predicate(...args) ? thenFn : elseFn, args);

export const ifDeff = (value, def) => (value !== undefined ? value : def);
